<script>
export default {
}
</script>
<template>
  <icon-base icon-name="Edit">
    <g>
      <path d="M12.3 3.7l4 4L4 20H0v-4L12.3 3.7zm1.4-1.4L16 0l4 4-2.3 2.3-4-4z" />
    </g>
  </icon-base>
</template>